import * as React from 'react';
const SvgBubbleLeftText = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M3.64 4.33C4.28 4 5.12 4 6.8 4h10.4c1.68 0 2.52 0 3.16.33.56.29 1.02.75 1.31 1.31.33.64.33 1.48.33 3.16v6.4c0 1.68 0 2.52-.33 3.16-.29.56-.75 1.02-1.31 1.31-.64.33-1.48.33-3.16.33h-6.17l-2.94 2.67c-.8.73-2.09.16-2.09-.92V20c-1.16 0-1.83-.05-2.36-.32-.56-.29-1.02-.75-1.31-1.31C2 17.73 2 16.89 2 15.21v-6.4c0-1.68 0-2.52.33-3.16.29-.56.75-1.02 1.31-1.31zM4 15.2c0 1 0 2.04.11 2.25.1.19.25.34.44.44.16.08.75.1 1.45.11h1c.28 0 .5.23.5.5v2.07l2.28-2.28a1 1 0 0 1 .71-.29h6.71c1 0 2.04 0 2.25-.11.19-.1.34-.25.44-.44.11-.21.11-1.25.11-2.25V8.8c0-1 0-2.04-.11-2.25-.1-.19-.25-.34-.44-.44C19.24 6 18.2 6 17.2 6H6.8c-1 0-2.04 0-2.25.11-.19.1-.34.25-.44.44C4 6.76 4 7.8 4 8.8z"
    />
    <path
      fill="currentColor"
      d="M6.27 10.05c.11-.05.25-.05.53-.05h10.4c.18 0 .3 0 .39.01.05 0 .1.02.14.04.09.05.17.12.22.22.05.11.05.25.05.53v.4c0 .28 0 .42-.05.53-.05.091-.12.171-.22.221-.11.05-.25.05-.53.05H6.8c-.28 0-.42 0-.53-.05a.5.5 0 0 1-.22-.22c-.02-.05-.04-.1-.04-.17v-.76c0-.28 0-.42.05-.53a.52.52 0 0 1 .22-.221zM6.27 14.049c.11-.05.25-.05.53-.05h4.4c.18 0 .3 0 .39.01.05 0 .1.02.14.04.09.05.17.12.22.22.05.11.05.25.05.53v.4c0 .28 0 .42-.05.53a.52.52 0 0 1-.22.221c-.11.05-.25.05-.53.05H6.8c-.28 0-.42 0-.53-.05a.52.52 0 0 1-.22-.22c-.02-.05-.04-.1-.04-.17v-.76c0-.28 0-.42.05-.53.05-.091.12-.171.22-.221z"
    />
  </svg>
);
export default SvgBubbleLeftText;
